import Backbone from 'backbone';
import $ from 'jquery';

import notifications from 'notifications';
import * as popup from 'Popup';

const MAX_QUICK_LINKS = 5;

class HomeView extends Backbone.View<Backbone.Model> {
  static initClass(): void {
    this.prototype.el = '#home';
    this.prototype.events = {
      // @ts-expect-error: Backbone events can be either the events hash or a method returning the events
      // hash. The Backbone types do not know about this.
      'click .collapse-toggle': 'toggleCollapse',
      'click .home-recently-accessed .delete-icon': 'deleteSequence',
    };
  }

  deleteSequence(e: JQueryEventObject): void {
    new popup.Confirm({
      title: 'Delete Sequence',
      msg: 'Are you sure you want to delete the sequence? It cannot be recovered.',
    })
      .choice('Cancel', 'btn-af-default')
      .choice('Delete', 'btn-af-danger', () =>
        $.ajax({
          type: 'DELETE',
          url: $(e.currentTarget).data('url'),
        })
          .fail(notifications.notifyError)
          .done(() => {
            $(e.currentTarget).closest('tr').remove();
            notifications.success('Sequence successfully deleted.');
          })
      )
      .show();
  }

  _hideExtraLinks($nav: JQuery): void {
    $nav.find('li').each(function (this: HTMLElement, i) {
      if ($(this).hasClass('collapse-toggle') || i < MAX_QUICK_LINKS) {
        return;
      }
      $(this).addClass('hidden');
    });
  }

  toggleCollapse(e: JQueryEventObject): void {
    const $target = $(e.currentTarget);
    const $nav = $target.closest('.nav-stacked');
    if ($target.hasClass('js-hiding')) {
      $target
        .addClass('js-showing')
        .removeClass('js-hiding')
        .find('a')
        .data({originalText: $target.text()})
        .empty()
        .append($('<span>').addClass('glyphicon glyphicon-chevron-up'));
      $nav.find('li').removeClass('hidden');
    } else {
      $target.addClass('js-hiding').removeClass('js-showing');
      const $a = $target.find('a');
      $a.text($a.data('originalText'));
      this._hideExtraLinks($nav);
    }
  }

  override render(): this {
    this.$('.quick-browse .collapse-toggle').each((_i, el) => {
      const $nav = $(el).closest('.nav-stacked');
      $(el).addClass('js-hiding');
      this._hideExtraLinks($nav);
    });
    this.$('.sort-toggle i').tooltip({
      container: 'body',
      placement: 'bottom',
    });

    const $inviteBtn = this.$('.home-invite-form .btn');
    $inviteBtn.toggleClass('disabled', !$inviteBtn.hasClass('verified'));
    const urlParts = window.location.href.split('?');
    if (urlParts.length > 1 && urlParts[1] === 'invite') {
      this.$('.home-invite-form input').focus();
    }

    return this;
  }
}
HomeView.initClass();

export default HomeView;
